module.exports = __webpack_public_path__ + "img/icon_goods_off.fe44c797.svg";